import React, { useEffect, useState } from "react";

function LoginPage() {
  const [valid, setValid] = useState(null);
  const [serialNumber, setSerialNumber] = useState("");
  const [loginSuccess, setLoginSuccess] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sn = params.get("serialNumber");
    setSerialNumber(sn);

    if (sn) {
      fetch(`/api/check-serial?serialNumber=${sn}`)
        .then((res) => (res.status === 404 ? setValid(false) : res.json()))
        .then((data) => data?.valid && setValid(true))
        .catch(() => setValid(false));
    } else {
      setValid(false);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const response = await fetch("/login", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.status === "ok") {
      setLoginSuccess(true); // ✅ Replace form with dialog
    } else {
      alert("❌ Login failed: " + result.message);
    }
  };

  if (valid === null) {
    return <h2 style={{ color: "white", textAlign: "center" }}>Checking...</h2>;
  }

  if (valid === false) {
    return (
      <h1 style={{ color: "red", textAlign: "center" }}>
        404 - Serial Not Found
      </h1>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3 col-md-2"></div>
        <div className="col-lg-6 col-md-8 login-box">
          <div className="login-key">
            <i className="fa fa-key" />
          </div>
          <div className="login-title">VVM Login</div>

          {/* ✅ If login success → show dialog instead of form */}
          {!loginSuccess ? (
            <div className="login-form">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-control-label">USERNAME</label>
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    required
                  />
                  <input
                    type="hidden"
                    name="serialNumber"
                    value={serialNumber}
                  />
                </div>
                <div className="form-group">
                  <label className="form-control-label">PASSWORD</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    required
                  />
                </div>
                <div className="loginbttm">
                  <div className="login-button">
                    <button type="submit" className="btn btn-outline-primary">
                      LOGIN
                    </button>
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <div className="login-form text-center" style={{ padding: "50px" }}>
              <h3 style={{ color: "#0DB8DE" }}>✅ Login Successful!</h3>
              <p style={{ color: "#ECF0F5" }}>Welcome to the system.</p>
            </div>
          )}
        </div>
        <div className="col-lg-3 col-md-2"></div>
      </div>
    </div>
  );
}

export default LoginPage;
